// extracted by mini-css-extract-plugin
module.exports = {"button":"BigButton_button__1X0r8","touch":"BigButton_touch__MoWbI"};